export default __webpack_public_path__ + "static/media/jobs-value-pursue-the-truth.50a296f9.svg";